import { BehindertenausweisModel } from '../../../../../shared/models/api/Behindertenausweis';
import { PersonalDataModel } from '../../../../../shared/models/view/PersonalData';
import { PartnerViewModel } from '../../../../../shared/models/view/Partner';
import { ChildModel } from '../../../../../shared/models/view/Child';
import { WerbeZustimmungModel } from '../../../../../shared/models/view/WerbeZustimmung';
import { MembershipBonusModel } from '../../../../../shared/models/view/MembershipBonus';
import { MembershipAddPersonsModel } from '../../../../../shared/models/view/MembershipAddPersons';
import { AppUtils } from '../../../../../shared/utils/index';

export class AppFormModel {

	constructor() {
		this.Bonus = new MembershipBonusModel();
	}

	private antragssteller: PersonalDataModel;
	public get Antragssteller(): PersonalDataModel {
		return this.antragssteller;
	}
	public set Antragssteller(v: PersonalDataModel) {
		this.antragssteller = v;
	}

	private partner: PartnerViewModel;
	public get Partner(): PartnerViewModel {
		return this.partner;
	}
	public set Partner(v: PartnerViewModel) {
		this.partner = v;
	}

	private kinder: Array<ChildModel> = new Array<ChildModel>();
	public get Kinder(): Array<ChildModel> {
		return this.kinder;
	}
	public set Kinder(v: Array<ChildModel>) {
		this.kinder = v;
	}

	private behindertenausweis: BehindertenausweisModel;
	public get Behindertenausweis(): BehindertenausweisModel {
		return this.behindertenausweis;
	}
	public set Behindertenausweis(v: BehindertenausweisModel) {
		this.behindertenausweis = v;
	}

	private werbeZustimmungModel: WerbeZustimmungModel;
	public get WerbeZustimmungModel(): WerbeZustimmungModel {
		return this.werbeZustimmungModel;
	}
	public set WerbeZustimmungModel(v: WerbeZustimmungModel) {
		this.werbeZustimmungModel = v;
	}

	private istSchwerbehindert: boolean;
	public get IstSchwerbehindert(): boolean {
		return this.istSchwerbehindert;
	}
	public set IstSchwerbehindert(v: boolean) {
		this.istSchwerbehindert = v;
	}

	private inAusbildung: boolean;
	public get InAusbildung(): boolean {
		return this.inAusbildung;
	}
	public set InAusbildung(v: boolean) {
		this.inAusbildung = v;
	}

	private ausbildungsende: string;
	public get Ausbildungsende(): string {
		return this.ausbildungsende;
	}
	public set Ausbildungsende(v: string) {
		this.ausbildungsende = v;
	}

	private bestimmungenAkzeptiert: boolean;
	public get BestimmungenAkzeptiert(): boolean {
		return this.bestimmungenAkzeptiert;
	}
	public set BestimmungenAkzeptiert(v: boolean) {
		this.bestimmungenAkzeptiert = v;
	}

	private wiederrufAkzeptiert: boolean;
	public get WiederrufAkzeptiert(): boolean {
		return this.wiederrufAkzeptiert;
	}
	public set WiederrufAkzeptiert(v: boolean) {
		this.wiederrufAkzeptiert = v;
	}

	private motorweltverzicht: boolean;
	public get Motorweltverzicht(): boolean {
		return this.motorweltverzicht;
	}
	public set Motorweltverzicht(v: boolean) {
		this.motorweltverzicht = v;
	}

	private profiwerbernummer: string;
	public get Profiwerbernummer(): string {
		return this.profiwerbernummer;
	}
	public set Profiwerbernummer(value: string) {
		this.profiwerbernummer = value;
	}

	private werbeschluessel: number;
	get Werbeschluessel(): number {
		return this.werbeschluessel;
	}
	set Werbeschluessel(value: number) {
		this.werbeschluessel = value;
	}

	private officeWerbeschluessel: number;
	get OfficeWerbeschluessel(): number {
		return this.officeWerbeschluessel;
	}
	set OfficeWerbeschluessel(value: number) {
		this.officeWerbeschluessel = value;
	}

	private werbetext: string;
	public get Werbetext(): string {
		return this.werbetext;
	}
	public set Werbetext(value: string) {
		this.werbetext = value;
	}

	private advertisingVersion: string;
	public get AdvertisingVersion(): string {
		return this.advertisingVersion;
	}
	public set AdvertisingVersion(value: string) {
		this.advertisingVersion = value;
	}

	private pruefziffer: number;
	public get Pruefziffer(): number {
		return this.pruefziffer;
	}
	public set Pruefziffer(value: number) {
		this.pruefziffer = value;
	}

	private mitgliedschaftstartdatum: string;
	public get MitgliedschaftStartDatum(): string {
		return this.mitgliedschaftstartdatum;
	}
	public set MitgliedschaftStartDatum(value: string) {
		this.mitgliedschaftstartdatum = value;
	}

	private bonus: MembershipBonusModel;
	public get Bonus(): MembershipBonusModel {
		return this.bonus;
	}
	public set Bonus(value: MembershipBonusModel) {
		this.bonus = value;
	}

	private bisherigeMitgliedsnummer: string;
	public get BisherigeMitgliedsnummer(): string {
		return this.bisherigeMitgliedsnummer;
	}
	public set BisherigeMitgliedsnummer(value: string) {
		this.bisherigeMitgliedsnummer = value;
	}

	private validierungscode: string;
	public get Validierungscode(): string {
		return this.validierungscode;
	}
	public set Validierungscode(value: string) {
		this.validierungscode = value;
	}

	private digitaleClubkarte: boolean;
	public get DigitaleClubkarte(): boolean {
		return this.digitaleClubkarte;
	}
	public set DigitaleClubkarte(value: boolean) {
		this.digitaleClubkarte = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AppFormModel {
		let childArr: Array<ChildModel>;
		return AppUtils.Helper.createFromMap(dataObject, AppFormModel, (key: string, value: any) => {
			switch (key) {
				case 'antragssteller':
					return PersonalDataModel.createFromObject(value);
				case 'partner':
					return PartnerViewModel.createFromObject(value);
				case 'kinder':
					childArr = new Array<ChildModel>();
					value.forEach((kind: Record<string, any>) => {
						childArr.push(ChildModel.createFromObject(kind));
					});
					return childArr;
				case 'behindertenausweis':
					return BehindertenausweisModel.createFromObject(value);
				case 'werbeZustimmungModel':
					return WerbeZustimmungModel.createFromObject(value);
				case 'bonus':
					return MembershipBonusModel.createFromObject(value);
				case 'addPersons':
					return MembershipAddPersonsModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}
